let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("amx2m")).then(() => parcelRequire('2e4H4'));